module.exports = __webpack_public_path__ + "static/media/abouticon1.a84f21a4.png";